// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import adminMenuItems from 'menu-items/adminMenuItems';
import { useGiraf } from 'giraf/index';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const { gHead } = useGiraf();
  const activeMenu = gHead.IsSuperAdmin ? adminMenuItems : menuItem;

  const navGroups = activeMenu.items?.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <Box sx={{ pt: 2, minHeight: '100%', display: 'flex', flexDirection: 'column' }}>
      {navGroups}
    </Box>
  );
};

export default Navigation;
